module.exports = __webpack_public_path__ + "static/media/180846730.d67754ea.png";